import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no-image.png'


const _withScopeId = n => (_pushScopeId("data-v-9649366a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-image-modal" }
const _hoisted_2 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "차량 사진", -1 /* HOISTED */))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "tabs-wrapper"
}
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_10 = {
  class: "bus-image-wrapper",
  ref: "busImageWrapper"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "bus-image",
  src: _imports_0,
  alt: "차량 없음"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1 /* HOISTED */))
const _hoisted_15 = {
  key: 1,
  class: "bus-image",
  src: _imports_0,
  alt: "차량 없음"
}
const _hoisted_16 = {
  key: 2,
  class: "overlay-text"
}
const _hoisted_17 = {
  key: 3,
  class: "overlay-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-backdrop",
      onClick: $setup.emitOnClickClose
    }),
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", _hoisted_3, [
                _hoisted_4,
                _createVNode($setup["InlineSvg"], {
                  class: "close-btn",
                  src: require('@/assets/icons/x-icon.svg'),
                  onClick: $setup.emitOnClickClose
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _createElementVNode("section", _hoisted_5, [
                ($props.buses.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.buses, (bus, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["tab-wrapper", { selected: $setup.selectedIndex === index }]),
                            key: bus.allocUid,
                            onClick: ($event: any) => ($setup.selectBusNumber(index))
                          }, _toDisplayString(bus.carNo ? $setup.slicePlateNumber(bus.carNo) : "-"), 11 /* TEXT, CLASS, PROPS */, _hoisted_8))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_10, [
                  ($setup.selectedBus.busImages?.length)
                    ? (_openBlock(), _createBlock($setup["Swiper"], _mergeProps({
                        key: 0,
                        ref: "swiperRef",
                        class: "bus-stop-swiper"
                      }, $setup.swiperOptions, { onSwiper: $setup.onSwiper }), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedBus.busImages, (busImage) => {
                            return (_openBlock(), _createBlock($setup["SwiperSlide"], {
                              key: busImage.fileUid
                            }, {
                              default: _withCtx(() => [
                                (busImage.fileUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "bus-image",
                                      src: busImage.fileUrl,
                                      onError: $setup.handleBusImageTagError,
                                      alt: "차량 이미지"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_12))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        _: 1 /* STABLE */
                      }, 16 /* FULL_PROPS */))
                    : (_openBlock(), _createElementBlock("img", _hoisted_15)),
                  ($setup.selectedBus.carNo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.selectedBus.carNo), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, "차량번호 정보가 없습니다"))
                ], 512 /* NEED_PATCH */)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}